import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Ewan from '../components/ewan'
import Features1 from '../components/features1'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container10">
      <Helmet>
        <title>Heidric Industrial Gas Trading</title>
        <meta property="og:title" content="Heidric Industrial Gas Trading" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Heidric Industrial Gas Trading" />
        <link
          rel="canonical"
          href="https://heidric-industrial-gas-trading-5gvzeu.teleporthq.site/"
        />
        <meta
          property="og:url"
          content="https://heidric-industrial-gas-trading-5gvzeu.teleporthq.site/"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"Organization","name":"Heidric Industrial Gas Trading","url":"https://heidric-industrial-gas-trading-5gvzeu.teleporthq.site"}',
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"WebSite","name":"Heidric Industrial Gas Trading","url":"https://heidric-industrial-gas-trading-5gvzeu.teleporthq.site"}',
          }}
        />
      </Helmet>
      <div data-modal="practices" id="tq-main" className="home-thq-modal-elm">
        <div className="home-thq-practices-elm">
          <div className="home-thq-heading-elm10">
            <span className="home-thq-header-elm10">Our practices</span>
            <svg
              viewBox="0 0 1024 1024"
              data-close="practices"
              className="home-thq-close-elm"
            >
              <path d="M225.835 286.165l225.835 225.835-225.835 225.835c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l225.835-225.835 225.835 225.835c16.683 16.683 43.691 16.683 60.331 0s16.683-43.691 0-60.331l-225.835-225.835 225.835-225.835c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0l-225.835 225.835-225.835-225.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331z"></path>
            </svg>
          </div>
          <div className="home-thq-grid-elm">
            <div className="home-thq-section-elm1">
              <div className="home-thq-heading-elm11">
                <span className="home-thq-header-elm11">Cardiology</span>
                <span className="home-thq-caption-elm10">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text100">Read more</span>
                <img
                  loading="eager"
                  decoding="async"
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  fetchpriority="high"
                  className="home-image10"
                />
              </div>
            </div>
            <div className="home-thq-section-elm2">
              <div className="home-thq-heading-elm12">
                <span className="home-thq-header-elm12">Orthopedics</span>
                <span className="home-thq-caption-elm11">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text101">Read more</span>
                <img
                  loading="eager"
                  decoding="async"
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image11"
                />
              </div>
            </div>
            <div className="home-thq-section-elm3">
              <div className="home-thq-heading-elm13">
                <span className="home-thq-header-elm13">Ophtalmology</span>
                <span className="home-thq-caption-elm12">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text102">Read more</span>
                <img
                  loading="eager"
                  decoding="async"
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image12"
                />
              </div>
            </div>
            <div className="home-thq-section-elm4">
              <div className="home-thq-heading-elm14">
                <span className="home-thq-header-elm14">Pediatrics</span>
                <span className="home-thq-caption-elm13">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text103">Read more</span>
                <img
                  loading="lazy"
                  decoding="async"
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image13"
                />
              </div>
            </div>
            <div className="home-thq-section-elm5">
              <div className="home-thq-heading-elm15">
                <span className="home-thq-header-elm15">Nutrition</span>
                <span className="home-thq-caption-elm14">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text104">Read more</span>
                <img
                  loading="lazy"
                  decoding="async"
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image14"
                />
              </div>
            </div>
            <div className="home-thq-section-elm6">
              <div className="home-thq-heading-elm16">
                <span className="home-thq-header-elm16">General</span>
                <span className="home-thq-caption-elm15">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text105">Read more</span>
                <img
                  loading="lazy"
                  decoding="async"
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image15"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="home-thq-hero-elm">
        <header className="home-thq-header-elm17">
          <header data-thq="thq-navbar" className="home-thq-navbar-elm">
            <div className="home-thq-left-elm1">
              <img
                loading="lazy"
                decoding="async"
                alt="image"
                src="/Branding/heidric%20icon%20logo-200h.png"
                className="home-thq-logo-elm"
              />
              <nav className="home-thq-links-elm1">
                <a href="#Home" className="home-thq-link-elm10">
                  Home
                </a>
                <span className="home-thq-link-elm11">About</span>
                <span className="home-thq-link-elm12">Why Us</span>
                <span className="home-thq-link-elm13">Featured Product</span>
                <a href="#Contact" className="home-thq-link-elm14">
                  Contact
                </a>
              </nav>
            </div>
            <div
              data-thq="thq-navbar-btn-group"
              className="home-thq-right-elm1"
            ></div>
            <div
              data-thq="thq-burger-menu"
              className="home-thq-burger-menu-elm"
            >
              <svg viewBox="0 0 1024 1024" className="home-icon11">
                <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
              </svg>
            </div>
            <div
              data-thq="thq-mobile-menu"
              className="home-thq-mobile-menu-elm"
            >
              <div
                data-thq="thq-mobile-menu-nav"
                data-role="Nav"
                className="home-thq-nav-elm1"
              >
                <div className="home-thq-container-elm">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="image"
                    src="/Branding/heidric%20icon%20logo-200h.png"
                    className="home-image16"
                  />
                  <div
                    data-thq="thq-close-menu"
                    className="home-thq-menu-close-elm"
                  >
                    <svg viewBox="0 0 1024 1024" className="home-icon13">
                      <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                    </svg>
                  </div>
                </div>
                <nav
                  data-thq="thq-mobile-menu-nav-links"
                  data-role="Nav"
                  className="home-thq-nav-elm2"
                >
                  <a href="#Home" className="home-thq-link-elm15">
                    Home
                  </a>
                  <span className="home-thq-link-elm16">About</span>
                  <span className="home-thq-link-elm17">Why Us</span>
                  <span className="home-thq-link-elm18">Featured Product</span>
                </nav>
              </div>
            </div>
          </header>
        </header>
        <div id="Home" className="home-thq-main-elm">
          <div className="home-thq-content-elm10">
            <div className="home-thq-heading-elm17">
              <h1 className="home-thq-header-elm18">
                <span>
                  Reliable Industrial Refrigeration
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="home-text109">Gas Solutions</span>
              </h1>
              <p className="home-thq-caption-elm16">
                <span className="home-text110">
                  Heidric Industrial Gas Trading
                </span>
                <span>
                  {' '}
                  is a trusted distributor of industrial refrigeration-grade
                  anhydrous ammonia, providing safe, reliable, and efficient
                  industrial gas solutions for businesses across Southern Luzon.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </p>
              <p className="home-thq-caption-elm17">
                <span className="home-text112">
                  Accredited Distributor of Centaur Chem Enterprise
                </span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </p>
            </div>
          </div>
          <img
            loading="lazy"
            decoding="async"
            alt="image"
            src="/ammonia%20gas%20heidric%202-800h.png"
            className="home-image17"
          />
        </div>
        <div id="features" className="home-thq-features-elm1">
          <div className="home-thq-content-elm11">
            <Features1
              header={
                <Fragment>
                  <span className="home-text114">
                    <span>Industrial Gas Supply</span>
                    <br />
                  </span>
                </Fragment>
              }
              description="Reliable distribution of refrigeration-grade anhydrous ammonia for industrial use."
            ></Features1>

            <Features1
              title="Ewan"
              header={
                <Fragment>
                  <span className="home-text117">
                    <span>Safe Storage &amp; Handling</span>
                    <br />
                  </span>
                </Fragment>
              }
              description="Strict safety protocols with regulated cylinder storage and controlled inventory."
            ></Features1>

            <Features1
              title="Tanginamo Dano"
              header={
                <Fragment>
                  <span className="home-text120">
                    <span>Fast Local Delivery</span>
                    <br />
                  </span>
                </Fragment>
              }
              description="Efficient logistics across Quezon Province for cold storage and food industries."
            ></Features1>
          </div>
        </div>
        <div className="home-thq-background-elm">
          <img
            loading="lazy"
            decoding="async"
            alt="image"
            src="/ammonia%20gas%20heidric%202-800h.png"
            className="home-image18"
          />
        </div>
        <section id="about-us" className="home-thq-about-us-elm about-us">
          <div className="about-us-container">
            <div className="about-us-rail"></div>
            <div className="about-us-split">
              <div className="about-us-label-col">
                <h1 className="home-thq-about-us-label-elm about-us-label">
                  About Us
                </h1>
              </div>
              <div className="about-us-content-col">
                <div className="about-us-panel home-thq-about-us-panel-elm">
                  <div className="about-us-text">
                    <h2 className="about-us-heading home-thq-about-us-heading-elm">
                      What is Heidric Industrial Gas Trading
                    </h2>
                    <div className="about-us-body">
                      <p className="home-text123">
                        Heidric Industrial Gas Trading stands as a cornerstone
                        of reliability in the industrial gas sector. We
                        specialize in the precise procurement and distribution
                        of high-purity industrial gases, ensuring that every
                        cylinder and bulk delivery meets the rigorous standards
                        of modern manufacturing and engineering.
                      </p>
                      <p className="home-text124">
                        Our commitment extends beyond mere supply; we partner
                        with our clients to optimize their operational
                        efficiency through consistent delivery schedules,
                        technical expertise, and a safety-first approach that
                        defines our organizational culture. With Heidric, you
                        gain an assured partner dedicated to the technical
                        excellence of your operations.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="why-us" className="home-thq-why-us-elm why-us">
          <div className="why-us-texture"></div>
          <div className="why-us-container">
            <div className="why-us-header">
              <h2 className="why-us-title">Why Us</h2>
            </div>
            <div className="why-us-bento">
              <div className="why-card">
                <div className="why-card-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="why-card-title">Safety First</h3>
                <p className="why-card-desc">
                  Uncompromising safety protocols governing every aspect of gas
                  handling and transport.
                </p>
              </div>
              <div className="why-card">
                <div className="why-card-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 17a2 2 0 1 0 4 0a2 2 0 1 0-4 0m10 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0"></path>
                      <path d="M5 17H3v-4M2 5h11v12m-4 0h6m4 0h2v-6h-8m0-5h5l3 5M3 9h4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="why-card-title">Reliable Distribution</h3>
                <p className="why-card-desc">
                  Strategic logistics network ensuring timely deliveries to keep
                  your production lines moving.
                </p>
              </div>
              <div className="why-card">
                <div className="why-card-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="8"
                        y="2"
                        rx="1"
                        ry="1"
                        width="8"
                        height="4"
                      ></rect>
                      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                      <path d="m9 14l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="why-card-title">Industry Compliance</h3>
                <p className="why-card-desc">
                  Full adherence to international industrial gas standards and
                  regulatory requirements.
                </p>
              </div>
              <div className="why-card">
                <div className="why-card-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 1a1 1 0 0 1 .823.443l.067.116l2.852 5.781l6.38.925c.741.108 1.08.94.703 1.526l-.07.095l-.078.086l-4.624 4.499l1.09 6.355a1 1 0 0 1-1.249 1.135l-.101-.035l-.101-.046l-5.693-3l-5.706 3q-.158.082-.32.106l-.106.01a1.003 1.003 0 0 1-1.038-1.06l.013-.11l1.09-6.355l-4.623-4.5a1 1 0 0 1 .328-1.647l.113-.036l.114-.023l6.379-.925l2.853-5.78A.97.97 0 0 1 12 1m0 3.274V16.75a1 1 0 0 1 .239.029l.115.036l.112.05l4.363 2.299l-.836-4.873a1 1 0 0 1 .136-.696l.07-.099l.082-.09l3.546-3.453l-4.891-.708a1 1 0 0 1-.62-.344l-.073-.097l-.06-.106z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <h3 className="why-card-title">Customer Commitment</h3>
                <p className="why-card-desc">
                  Dedicated support teams focused on solving your specific
                  technical gas supply challenges.
                </p>
              </div>
              <div className="why-card-spotlight why-card home-thq-why-card-elm5">
                <div className="why-card-icon">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="image"
                    src="/Icons/handshake-svgrepo-com.svg"
                    className="home-image19"
                  />
                </div>
                <h3 className="why-card-title">Trusted Partner</h3>
                <p className="why-card-desc">
                  A legacy of trust built on transparent trading and consistent
                  technical performance.
                </p>
              </div>
            </div>
          </div>
        </section>
        <div className="home-container11">
          <div className="home-container12">
            <Script
              html={`<script defer data-name="about-us-scroll">
(function(){
// Subtle reveal for about us rail
const rail = document.querySelector('.about-us-rail');
if (rail) {
  window.addEventListener('scroll', () => {
    const scrollPos = window.scrollY;
    rail.style.opacity = Math.min(scrollPos / 500, 1);
  });
}
})()
</script>`}
            ></Script>
          </div>
        </div>
      </section>
      <section className="home-thq-features-elm2">
        <div className="home-thq-section-elm7">
          <div className="home-thq-content-elm12">
            <div className="home-thq-header-elm19">
              <h2 className="home-thq-specs-elm1">Specifications</h2>
              <table className="home-table">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody className="home-tbody">
                  <tr>
                    <td>
                      <span className="home-text125">Product Name</span>
                    </td>
                    <td>
                      <span>Industrial Refrigeration Grade Ammonia</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="home-text127">Packaging</span>
                    </td>
                    <td>
                      <span>Heavy-Duty Steel Cylinder</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="home-text129">Cylinder Capacity</span>
                    </td>
                    <td>
                      <span>65 kg</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="home-text131">Product Type</span>
                    </td>
                    <td>
                      <span>Industrial Refrigeration Gas</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="home-text133">Storage</span>
                    </td>
                    <td>
                      <span>Sealed Steel Cylinders</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <img
            loading="lazy"
            decoding="async"
            alt="image"
            src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
            className="home-image20"
          />
        </div>
        <div className="home-thq-section-elm8">
          <div className="home-thq-content-elm13">
            <div className="home-thq-header-elm20">
              <h2 className="home-thq-heading-elm18">Common Applications</h2>
              <ul className="list">
                <li className="list-item">
                  <span>- Cold Storage Facilities</span>
                </li>
                <li className="list-item">
                  <span>- Ice Plants</span>
                </li>
                <li className="list-item">
                  <span>- Food Processing</span>
                </li>
                <li className="list-item">
                  <span>- Agricultural Storage</span>
                </li>
                <li className="list-item">
                  <span>- Poultry Processing</span>
                </li>
                <li className="list-item">
                  <span>- Industrial Refrigeration</span>
                </li>
              </ul>
            </div>
          </div>
          <img
            loading="lazy"
            decoding="async"
            alt="image"
            src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
            className="home-image21"
          />
        </div>
        <button className="home-thq-book-elm3 button button-main">
          <span>Book a virtual appointment</span>
        </button>
      </section>
      <section
        id="featured product"
        className="home-thq-featured-product-elm1"
      ></section>
      <section id="featured product" className="home-thq-featured-product-elm2">
        <div className="home-thq-section-elm9">
          <div className="home-container13">
            <div className="home-container14">
              <div className="home-thq-header-elm21">
                <div className="home-container15">
                  <div className="home-thq-header-elm22">
                    <h1 className="home-thq-heading-elm19">Featured Product</h1>
                    <h1 className="home-thq-heading-elm20">
                      Industrial Refrigeration Grade Ammonia
                    </h1>
                    <p className="home-thq-caption-elm18">
                      <span className="home-text142">
                        Heidric supplies premium industrial refrigeration-grade
                        anhydrous ammonia, recognized as one of the most
                        efficient and environmentally sustainable refrigerants
                        used in industrial cooling systems.
                      </span>
                      <br className="home-text143"></br>
                      <br className="home-text144"></br>
                      <span className="home-text145">
                        Our product is stored exclusively in heavy-duty
                        65-kilogram steel cylinders, ensuring safe storage,
                        transportation, and reliable performance for industrial
                        applications.
                      </span>
                    </p>
                    <Link to="/product-specification" className="home-navlink1">
                      <div className="home-thq-type-elm1 book-type">
                        <span className="home-text146">
                          <span className="home-text147">
                            See Full Product Specification
                          </span>
                          <span>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: ' ',
                              }}
                            />
                          </span>
                        </span>
                      </div>
                    </Link>
                    <div className="home-container16">
                      <div className="home-container17">
                        <div className="home-thq-specs-elm2 symptom">
                          <span className="home-text149">
                            Heavy-Duty Steel Cylinder
                          </span>
                        </div>
                      </div>
                      <div className="home-thq-specs-elm3 symptom">
                        <span className="home-text150">65 kg</span>
                      </div>
                    </div>
                    <div className="home-container18">
                      <div className="home-container19">
                        <div className="home-thq-specs-elm4 symptom">
                          <span className="home-text151">
                            Industrial Refrigeration Gas
                          </span>
                        </div>
                      </div>
                      <div className="home-thq-specs-elm5 symptom">
                        <span className="home-text152">
                          Sealed Steel Cylinders
                        </span>
                      </div>
                    </div>
                    <div className="home-container20">
                      <div className="home-container21">
                        <div className="home-thq-specs-elm6 symptom">
                          <span className="home-text153">
                            99.98% NH3
                            <span
                              dangerouslySetInnerHTML={{
                                __html: ' ',
                              }}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            loading="lazy"
            decoding="async"
            alt="image"
            src="/ammonia%20gas%20heidric%202-800h.png"
            className="home-image22"
          />
        </div>
      </section>
      <div className="home-thq-our-commitment-elm1">
        <div className="home-thq-heading-elm21">
          <h2 className="home-text154">OUR COMMITMENT</h2>
          <p className="home-text155">
            Dedicated to Safety, Reliability, and Responsible Operations
          </p>
        </div>
        <div className="home-thq-content-elm14">
          <div className="home-thq-type-two-elm1">
            <div className="home-thq-heading-elm22">
              <h3 className="home-text156">Safety &amp; Compliance</h3>
              <p className="home-text157">
                <span>
                  Safety is the cornerstone of our operations. We implement
                  rigorous procedures in the storage, handling, and
                  transportation of industrial refrigeration-grade gases to
                  ensure a secure and controlled working environment at all
                  times.
                </span>
                <br className="home-text159"></br>
                <br className="home-text160"></br>
                <span>
                  We strictly enforce proper handling practices, utilize
                  appropriate equipment for transport, and maintain structured
                  workflows that eliminate unsafe conditions. Every movement
                  from intake and storage to delivery is carefully managed to
                  uphold safety and efficiency.
                </span>
                <br className="home-text162"></br>
                <br className="home-text163"></br>
                <span>
                  Beyond compliance, we take a proactive approach to risk
                  management by fostering a culture of awareness,
                  responsibility, and continuous improvement among our
                  personnel. This ensures that safety is not only followed but
                  consistently practiced and strengthened over time.
                </span>
                <br className="home-text165"></br>
                <br className="home-text166"></br>
                <span>
                  Through these commitments, we safeguard our employees, protect
                  our clients’ operations, and help maintain the integrity of
                  the industries we support—particularly in refrigeration, cold
                  storage, and food preservation sectors.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="home-thq-our-commitment-elm2">
        <div className="home-thq-content-elm15">
          <div className="home-thq-type-two-elm2">
            <div className="home-thq-heading-elm23">
              <h3 className="home-text168">
                We do not compromise on safety, quality, or responsibility
                because our commitment defines the standard of service we
                deliver.
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="home-thq-search-elm">
        <div className="home-thq-heading-elm24">
          <h2 className="home-text169">OUR COMMITMENT</h2>
          <p className="home-text170">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt.
          </p>
        </div>
        <div className="home-thq-content-elm16">
          <div className="home-thq-type-two-elm3">
            <div className="home-thq-heading-elm25">
              <h3 className="home-text171">Symptom checker</h3>
              <p className="home-text172">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt.
              </p>
            </div>
            <div className="home-thq-symptoms-elm">
              <div className="home-thq-row-elm1">
                <div className="symptom">
                  <span className="home-text173">Abdominal pain</span>
                </div>
                <div className="symptom">
                  <span className="home-text174">Chest pain</span>
                </div>
                <div className="symptom">
                  <span className="home-text175">Constipation</span>
                </div>
                <div className="symptom">
                  <span className="home-text176">Cough</span>
                </div>
                <div className="symptom">
                  <span className="home-text177">Breath difficulty</span>
                </div>
              </div>
              <div className="home-thq-row-elm2">
                <div className="symptom">
                  <span className="home-text178">Red eye</span>
                </div>
                <div className="symptom">
                  <span className="home-text179">Foot pain</span>
                </div>
                <div className="symptom">
                  <span className="home-text180">Foot swelling</span>
                </div>
                <div className="symptom">
                  <span className="home-text181">Headache</span>
                </div>
                <div className="symptom">
                  <span className="home-text182">Heart palpitation</span>
                </div>
              </div>
              <div className="home-thq-row-elm3">
                <div className="symptom">
                  <span className="home-text183">Knee pain</span>
                </div>
                <div className="symptom">
                  <span className="home-text184">Hip pain</span>
                </div>
                <div className="symptom">
                  <span className="home-text185">Low back pain</span>
                </div>
                <div className="symptom">
                  <span className="home-text186">Nasal congestion</span>
                </div>
                <div className="symptom">
                  <span className="home-text187">Neck pain</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="home-thq-meet-elm">
        <div className="home-thq-heading-elm26">
          <h2 className="home-text188">INDUSTRIES WE CAN SERVE</h2>
          <div className="home-container22">
            <div
              data-teleport="doctors"
              className="home-thq-industries-we-serve-row-elm1"
            >
              <Ewan
                text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
                heading1={
                  <Fragment>
                    <span className="home-text189">
                      Ice Manufacturing Plants
                    </span>
                  </Fragment>
                }
                imageSrc="/ice-300w.jpeg"
              ></Ewan>
              <Ewan
                heading1={
                  <Fragment>
                    <span className="home-text190">
                      Cold Storage Facilities
                    </span>
                  </Fragment>
                }
                imageSrc="/a-large-cold-storage-warehouse-300w.jpg"
              ></Ewan>
            </div>
            <div
              data-teleport="doctors"
              className="home-thq-industries-we-serve-row-elm2"
            >
              <Ewan
                text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
                heading1={
                  <Fragment>
                    <span className="home-text191">
                      Food Processing Companies
                    </span>
                  </Fragment>
                }
                imageSrc="/food%20processing%20companies-300w.jpeg"
              ></Ewan>
              <Ewan
                heading1={
                  <Fragment>
                    <span className="home-text192">
                      Agricultural Businesses
                    </span>
                  </Fragment>
                }
                imageSrc="/agricultural%20businesses-300w.png"
              ></Ewan>
            </div>
          </div>
          <div className="home-container23">
            <div
              data-teleport="doctors"
              className="home-thq-industries-we-serve-row-elm3"
            >
              <Ewan
                heading1={
                  <Fragment>
                    <span className="home-text193">
                      Poultry Processing Facilities
                    </span>
                  </Fragment>
                }
                imageSrc="/poultry%20processing%20facilities-300w.jpg"
              ></Ewan>
              <Ewan
                heading1={
                  <Fragment>
                    <span className="home-text194">
                      Industrial Refrigeration Contractors
                    </span>
                  </Fragment>
                }
                imageSrc="/industrial%20refrigeration%20contractors-300w.jpeg"
              ></Ewan>
            </div>
          </div>
        </div>
      </section>
      <section className="home-thq-aboutpage-elm1">
        <div className="home-thq-heading-elm27">
          <h2 className="home-text195">ABOUT PAGE</h2>
        </div>
        <div className="home-thq-content-elm17">
          <div className="home-thq-heading-elm28">
            <h3 className="home-thq-header-elm23">Our Story</h3>
            <p className="home-thq-caption-elm19">
              <span className="home-text196">
                Heidric Industrial Gas Trading was established to provide
                businesses with dependable access to industrial
                refrigeration-grade ammonia while maintaining uncompromising
                standards of safety and operational excellence.
              </span>
              <br className="home-text197"></br>
              <br className="home-text198"></br>
              <span className="home-text199">
                By specializing in a single industrial gas product, the company
                is able to maintain focused expertise, efficient inventory
                management, and strict compliance with industry regulations.
              </span>
              <br className="home-text200"></br>
              <br className="home-text201"></br>
              <span className="home-text202">
                Today, Hedrc continues to support businesses throughout Southern
                Luzon by providing reliable refrigeration solutions essential to
                food preservation, agriculture, and industrial operations.
              </span>
            </p>
          </div>
        </div>
        <hr className="home-separator"></hr>
        <div className="home-thq-content-elm18">
          <Features1
            header={
              <Fragment>
                <span className="home-text203">Mission</span>
              </Fragment>
            }
            description="To provide safe, reliable, and efficient industrial gas distribution while maintaining the highest standards of operational safety, customer satisfaction, and regulatory compliance."
            rootClassName="features1root-class-name"
          ></Features1>
          <Features1
            header={
              <Fragment>
                <span className="home-text204">Vision</span>
              </Fragment>
            }
            description="To become one of Southern Luzon's most trusted industrial gas distributors through dependable service, responsible operations, and long-term partnerships."
            rootClassName="features1root-class-name1"
          ></Features1>
        </div>
      </section>
      <section className="home-thq-aboutpage-elm2">
        <div className="home-thq-heading-elm29">
          <h2 className="home-text205">SDS PAGE</h2>
        </div>
        <div className="home-thq-content-elm19">
          <div className="home-thq-heading-elm30">
            <h3 className="home-thq-header-elm24"> Safety Data Sheet</h3>
            <p className="home-thq-caption-elm20">
              <span className="home-text206">
                Safety is an integral part of our operations.
              </span>
              <br className="home-text207"></br>
              <span>
                This page provides customers with access to Safety Data Sheets
                (SDS) and Product Specification for Industrial Refrigeration
                Grade Ammonia.
              </span>
            </p>
          </div>
        </div>
        <div className="home-thq-types-elm1">
          <a
            href="https://storage.googleapis.com/playground-bucket-v2.teleporthq.io/1b2d6d88-75e2-489b-a900-c31ddca8c413/208e0fd9-b910-47a1-b159-8582b7f5f650"
            target="_blank"
            rel="noreferrer noopener"
            className="home-link1"
          >
            <div className="home-thq-type-elm2 book-type">
              <span className="home-text209"> Safety Data Sheet</span>
            </div>
          </a>
          <Link to="/product-specification" className="home-navlink2">
            <div className="home-thq-type-elm3 book-type">
              <span className="home-text210">
                Product Specification
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
          </Link>
        </div>
      </section>
      <div className="home-thq-list-elm1">
        <div className="home-thq-controls-elm"></div>
      </div>
      <section id="Contact" className="home-thq-contact-elm">
        <div className="home-thq-heading-elm31">
          <h2 className="home-text211">Contact Us</h2>
          <p className="home-text212">
            We are ready to support your industrial refrigeration needs.
          </p>
        </div>
        <div className="home-thq-heading-elm32">
          <h4 className="home-text213">Address</h4>
          <p className="home-text214">
            Barangay Sta. Catalina Sur Candelaria, Quezon Province
          </p>
        </div>
        <div className="home-thq-heading-elm33">
          <h4 className="home-text215">Contact Numbers</h4>
          <p className="home-text216">
            <span className="home-text217">+63 949 363 8688</span>
            <br className="home-text218"></br>
            <span className="home-text219">+63 919 998 8580</span>
          </p>
        </div>
        <div className="home-thq-heading-elm34">
          <h4 className="home-text220">Email</h4>
          <a
            href="mailto:HeidricIGT.ops@gmail.com?subject="
            className="home-link2"
          >
            <p className="home-text221">HeidricIGT.ops@gmail.com</p>
          </a>
        </div>
      </section>
      <section id="book" className="home-thq-book-elm4">
        <div className="home-thq-heading-elm35">
          <h2 className="home-text222">Book an appointment</h2>
          <p className="home-text223">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt.
          </p>
        </div>
        <div className="home-thq-form-elm">
          <div className="home-thq-types-elm2">
            <div className="book-type">
              <span className="home-text224">In person appointment</span>
            </div>
            <div className="home-thq-type-elm5 book-type">
              <span className="home-text225">Virtual appointment</span>
            </div>
          </div>
          <div className="home-thq-inputs-elm">
            <input
              type="text"
              placeholder="Name"
              autoComplete="name"
              className="input book-input"
            />
            <input
              type="email"
              placeholder="Email"
              autoComplete="email"
              className="input book-input"
            />
            <input
              type="tel"
              placeholder="Phone"
              autoComplete="tel"
              className="input book-input"
            />
            <div className="home-thq-date-elm1">
              <input
                type="date"
                placeholder="Date"
                className="input book-input"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image"
                src="/Icons/calendar-2.svg"
                className="home-image23"
              />
            </div>
            <input
              type="text"
              placeholder="Practice"
              className="input book-input"
            />
            <div className="home-thq-lower-elm">
              <p className="home-text226">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt.
              </p>
              <div className="home-thq-button-elm">
                <button className="home-thq-book-elm5 button button-main">
                  <span>Book</span>
                </button>
                <p className="home-text228">
                  <span>
                    Lorem ipsum dolor sit amet, consectetur
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="home-text230">adipiscing elit</span>
                  <span>
                    , sed do eiusmod tempor
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="home-text232">incididunt</span>
                  <span>.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="home-thq-news-elm">
        <div className="home-thq-heading-elm36">
          <h2 className="home-text234">Read our latest news</h2>
          <p className="home-text235">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt.
          </p>
        </div>
        <div className="home-thq-list-elm2">
          <div className="home-thq-item-elm1">
            <div className="home-thq-image-elm1">
              <img
                loading="lazy"
                decoding="async"
                alt="image"
                src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                className="home-image24"
              />
            </div>
            <div className="home-thq-content-elm20">
              <div className="home-thq-details-elm1">
                <span className="home-thq-date-elm2">November 23, 2022</span>
                <p className="home-thq-quick-description-elm1">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
              </div>
              <div className="read-more">
                <span className="home-text236">Read more</span>
                <img
                  loading="lazy"
                  decoding="async"
                  alt="image"
                  src="/Icons/arrow.svg"
                  className="home-image25"
                />
              </div>
            </div>
          </div>
          <div className="home-thq-item-elm2">
            <div className="home-thq-image-elm2">
              <img
                loading="lazy"
                decoding="async"
                alt="image"
                src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                className="home-image26"
              />
            </div>
            <div className="home-thq-content-elm21">
              <div className="home-thq-details-elm2">
                <span className="home-thq-date-elm3">November 23, 2022</span>
                <p className="home-thq-quick-description-elm2">
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa
                  qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
              <div className="read-more">
                <span className="home-text237">Read more</span>
                <img
                  loading="lazy"
                  decoding="async"
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image27"
                />
              </div>
            </div>
          </div>
          <div className="home-thq-item-elm3">
            <div className="home-thq-image-elm3">
              <img
                loading="lazy"
                decoding="async"
                alt="image"
                src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                className="home-image28"
              />
            </div>
            <div className="home-thq-content-elm22">
              <div className="home-thq-details-elm3">
                <span className="home-thq-date-elm4">November 23, 2022</span>
                <p className="home-thq-quick-description-elm3">
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                  accusantium doloremque laudantium, totam rem aperiam, eaque
                  ipsa quae ab illo inventore.
                </p>
              </div>
              <div className="read-more">
                <span className="home-text238">Read more</span>
                <img
                  loading="lazy"
                  decoding="async"
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image29"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="home-thq-footer-elm">
        <div className="home-thq-left-elm2">
          <div className="home-thq-brand-elm">
            <img
              loading="lazy"
              decoding="async"
              alt="image"
              src="/Branding/heidric%20icon%20logo-200h.png"
              className="home-image30"
            />
          </div>
          <div className="home-thq-legal-elm1">
            <span className="home-thq-copyright-elm1">
              © 2022 Heidric Industrial Gas. All Rights Reserved.
            </span>
          </div>
        </div>
        <div className="home-thq-right-elm2">
          <div className="home-thq-list-elm3">
            <span className="home-thq-header-elm25">Menu</span>
            <div className="home-thq-links-elm2">
              <a href="#Home" className="home-thq-link-elm19">
                Home
              </a>
              <span className="home-thq-link-elm20">About</span>
              <span className="home-thq-link-elm21">Why Us</span>
              <span className="home-thq-link-elm22">Featured Product</span>
              <a href="#Contact" className="home-thq-link-elm23">
                Contact
              </a>
            </div>
          </div>
          <div className="home-thq-list-elm4">
            <span className="home-thq-header-elm26">Contact</span>
            <div className="home-thq-links-elm3">
              <span className="home-thq-link-elm24">
                Barangay Sta. Catalina Sur Candelaria, Quezon Province
              </span>
              <a
                href="mailto:contact@template.new?subject=Main"
                className="home-thq-link-elm25"
              >
                HeidricIGT.ops@gmail.com
              </a>
              <a href="tel:(004) 234 - 5678" className="home-thq-link-elm26">
                +63 949 363 8688
              </a>
              <a href="tel:(004) 234 - 5678" className="home-thq-link-elm27">
                +63 919 998 8580
              </a>
            </div>
          </div>
        </div>
        <div className="home-thq-legal-elm2">
          <div className="home-thq-row-elm4">
            <span className="legal-link">Privacy Policy</span>
            <span className="legal-link">Terms of Use</span>
          </div>
          <span className="home-thq-copyright-elm4">
            © 2022 finbest. All Rights Reserved.
          </span>
        </div>
      </div>
    </div>
  )
}

export default Home
